var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.action,style:(_vm.color),attrs:{"id":"button"},on:{"click":_vm.update}},[_vm._v(" "+_vm._s(this.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }